module.exports = __webpack_public_path__ + "static/image/service/pc/robot2@3x.ver2_0_2.jpg?f5ad504e";